import { useMemo } from "react";
import { useBookings } from "@/hooks/useBookings";
import { BookingStatus } from "@/types/activities";

/**
 * Number of "new" bookings — status `PendingVendorContact`, the one stage where the
 * Athlyn team must act first (ps-cms-shell T4, the Bookings menu badge).
 *
 * Calls `useBookings()` with no params, so it shares the `['bookings', {}]` React
 * Query cache entry with every other parameterless caller. `undefined` while the
 * list is loading or failed — the badge then renders nothing.
 */
export function useNewBookingsCount(): number | undefined {
  const { data, loading, error } = useBookings();
  return useMemo(() => {
    if (loading || error || !data) return undefined;
    return data.filter((booking) => booking.status === BookingStatus.PendingVendorContact).length;
  }, [data, loading, error]);
}
